import React, { useContext, useRef, useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router';
import { chevronForwardCircle, chevronBackCircleOutline, chevronDownCircleOutline } from 'ionicons/icons';
// TODO: Uncomment when delivery functionality is needed
// import { v4 as uuidv4 } from 'uuid';
import {
  IonContent,
  IonGrid,
  IonCol,
  IonRow,
  IonItem,
  IonIcon,
  IonPage,
  IonSegmentButton,
  IonLabel,
  IonSegment,
  // TODO: Uncomment when delivery functionality is needed
  // IonButton,
  IonList,
  IonHeader,
  IonButton,
  IonModal,
  IonToolbar,
  IonInput,
  // IonTitle,
  IonSearchbar,
  IonButtons,
  // TODO: Uncomment when delivery functionality is needed
  // IonCard,
} from '@ionic/react';
import { AppContext, AppDispatchContext, ACTIONS } from '../../global/AppContext';
import MatchmakingContext from '../../global/MatchmakingContext';
// TODO: Uncomment when delivery functionality is needed
// import { updateAddress, getPastAddresses } from '../../global/request/user';
import useProfile from '../../global/useProfile';
import useRestaurants from '../../global/useRestaurants';
// TODO: Uncomment when delivery functionality is needed
// import RestaurantMap from '../../googleMapsApi/RestaurantMap';
import useGoogleMapsLoader from '../../googleMapsApi/useGoogleMapsLoader';
// import AddressFields from '../addressFields/AddressFields';
import RestaurantModal from './RestaurantModal';
// TODO: Uncomment when delivery functionality is needed
// import RestaurantSkeletonTile from './RestaurantSkeletonTile';
import RestaurantTile from './RestaurantTile';

import '../../styles/restaurant/Restaurant.scss';
// import '@fortawesome/fontawesome-free/css/all.min.css';

function Restaurant() {
  const appCtx = useContext(AppContext);
  // eslint-disable-next-line no-unused-vars
  const appDispatchCtx = useContext(AppDispatchContext);
  const history = useHistory();
  const [, profile] = useProfile();

  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  // eslint-disable-next-line no-unused-vars
  // const [reload, restaurants] = useRestaurants();
  // eslint-disable-next-line no-unused-vars
  const [reload, restaurants] = useRestaurants(); // const [reload, restaurantsList] = useRestaurants(); -> for testing
  // const [restaurants, setRestaurants] = useState([]); -> for testing
  // TODO: Uncomment when delivery functionality is needed
  // const [segmentValue, setSegmentValue] = useState(appCtx.isDelivery ? 'delivery' : 'inPerson');
  const [segmentValue, setSegmentValue] = useState('inPerson');
  const modalRef = useRef(null);
  const { dispatch } = useContext(MatchmakingContext);
  // TODO: Uncomment when delivery functionality is needed
  // const [isFormValid, setIsFormValid] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const [searchVenue, setSearchVenue] = useState('');
  const [searchCity, setSearchCity] = useState('');
  // TODO: Uncomment when delivery functionality is needed
  // const [addressDetails, setAddressDetails] = useState({
  //   streetAddress: '',
  //   apt: '',
  //   city: '',
  //   state: '',
  //   zip: '',
  // });
  // const [pastAddresses, setPastAddresses] = useState([]);
  // TODO: Uncomment when delivery functionality is needed
  // const bearerToken = authCtx.tokens.idToken;
  // const skeletonKeys = useRef([...Array(6)].map(() => uuidv4()));
  const [transformedRestaurants, setTransformedRestaurants] = useState([]);
  // const [selectedLocation, setSelectedLocation] = useState(null);
  // const [activePastAddress, setActivePastAddress] = useState('');
  // const [isAddressCollapsed, setIsAddressCollapsed] = useState(false);
  // const geocoderRef = useRef(null);
  const { isLoaded } = useGoogleMapsLoader();
  const [selectedCity, setSelectedCity] = useState('All Cities');
  const [selectingCity, setSelectingCity] = useState(false);
  const [allowedStates, setAllowedStates] = useState([]);
  // TODO: Uncomment when delivery functionality is needed
  // const geocodedLocationsCache = useRef(new Map());

  // TODO: Uncomment when delivery functionality is needed
  // const dispatchIsAddressAutocompleted = useCallback(
  //   isAutocompleted => {
  //     appDispatchCtx.dispatch({
  //       action: ACTIONS.SET_ADDRESS_AUTOCOMPLETED,
  //       payload: isAutocompleted,
  //     });
  //   },
  //   [appDispatchCtx],
  // );

  // TODO: Uncomment when delivery functionality is needed
  // const handleLocationSelect = location => {
  //   setSelectedLocation(location);

  //   if (location.formatted_address) {
  //     const addressParts = location.formatted_address.split(', ');
  //     const updatedDetails = {
  //       streetAddress: addressParts[0] || '',
  //       apt: '',
  //       city: addressParts[1] || '',
  //       state: addressParts[2]?.split(' ')[0] || '',
  //       zip: addressParts[2]?.split(' ')[1] || '',
  //     };
  //     setAddressDetails(updatedDetails);
  //     setIsFormValid(true);
  //   }

  //   appDispatchCtx.dispatch({
  //     action: ACTIONS.SET_DELIVERY_LATITUDE,
  //     payload: location.lat,
  //   });
  //   appDispatchCtx.dispatch({
  //     action: ACTIONS.SET_DELIVERY_LONGITUDE,
  //     payload: location.lng,
  //   });
  // };

  useEffect(() => {
    const filteredStates = restaurants
      .reduce((acc, rest) => {
        if (
          (rest.dineIn === true && segmentValue === 'inPerson') ||
          (rest.delivery === true && segmentValue === 'delivery')
        ) {
          if (rest.state) {
            const existingState = acc.find(item => item.state === rest.state);
            if (existingState) {
              existingState.cities.add(rest.city);
            } else {
              acc.push({ state: rest.state, cities: new Set([rest.city]) });
            }
          }
        }

        return acc;
      }, [])
      .map(item => ({
        state: item.state,
        cities: Array.from(item.cities).sort((a, b) => a.localeCompare(b)),
      }))
      .sort((a, b) => a.state.localeCompare(b.state));
    setAllowedStates(filteredStates);
  }, [restaurants, segmentValue]);

  // TODO: Uncomment when delivery functionality is needed
  // const fetchPastAddresses = useCallback(async () => {
  //   setPastAddresses(await getPastAddresses(bearerToken));
  // }, [bearerToken, setPastAddresses]);

  useEffect(() => {
    if (history.location.state && history.location.state.tab) {
      // TODO: Uncomment when delivery functionality is needed
      // setSegmentValue(history.location.state.tab);
      setSegmentValue('inPerson');
    }
  }, [history.location.state]);

  useEffect(() => {
    if (!['/app/restaurant', '/app/restaurant/'].includes(history.location.pathname)) {
      appDispatchCtx.dispatch({
        action: ACTIONS.SET_ON_SELECT_VENUE,
        payload: null,
      });
    }
  }, [history.location.pathname, appDispatchCtx]);

  // TODO: Uncomment when delivery functionality is needed
  // const handleAddressSubmit = async () => {
  //   const trimmedApt = addressDetails.apt?.replace(' ', '');
  //   const formattedAddress = `${addressDetails.streetAddress}${trimmedApt ? ` ${trimmedApt}` : ''}, ${
  //     addressDetails.city
  //   }, ${addressDetails.state} ${addressDetails.zip}`;

  //   try {
  //     await updateAddress(bearerToken, formattedAddress);

  //     // appDispatchCtx.dispatch({
  //     //   action: ACTIONS.SET_RESTAURANT,
  //     //   restaurant: { ...appCtx.restaurant, address: formattedAddress },
  //     // });

  //     appDispatchCtx.dispatch({
  //       action: ACTIONS.SET_DELIVERY_ADDRESS,
  //       payload: formattedAddress,
  //     });

  //     setActivePastAddress(formattedAddress);
  //     setIsAddressCollapsed(true);
  //     // setSelectedRestaurant({ ...appCtx.restaurant, address: formattedAddress });
  //     dispatch({ type: 'TRIGGER_GET_LIVE_BETS' });
  //     fetchPastAddresses();
  //   } catch (error) {
  //     console.error('Failed to update address for delivery:', error);
  //   }
  // };

  const handleSelectRestaurant = rest => {
    dispatch({
      type: 'SET_SELECTED_RESTAURANT',
      payload: rest,
    });
    setSelectedRestaurant(rest);
    modalRef.current.present();
  };

  // TODO: Uncomment when delivery functionality is needed
  // useEffect(() => {
  //   fetchPastAddresses();
  // }, [fetchPastAddresses]);

  useEffect(() => {
    if (appCtx.restaurant) {
      setSelectedRestaurant(appCtx.restaurant);
    }
  }, [appCtx.restaurant]);

  const sortRestaurants = useCallback(
    rests => {
      let selectedRestaurantId;

      if (appCtx.restaurant) {
        selectedRestaurantId = appCtx.restaurant.id;
      }

      const sorted = rests
        .filter(
          rest =>
            (rest.dineIn === true && segmentValue === 'inPerson') ||
            (rest.delivery === true && segmentValue === 'delivery'),
        )
        .filter(rest => rest.id !== 44 && rest.id !== 64)
        .filter(rest => selectedCity === 'All Cities' || `${rest.city}, ${rest.state}` === selectedCity)
        .filter(rest => {
          if (!searchVenue) return true;
          return rest.name.toLowerCase().includes(searchVenue.toLowerCase());
        })
        .sort(
          (a, b) =>
            (b.id === selectedRestaurantId) - (a.id === selectedRestaurantId) ||
            (a.distance || Infinity) - (b.distance || Infinity) ||
            a.name.localeCompare(b.name),
        );

      return sorted;
    },
    [appCtx.restaurant, selectedCity, searchVenue, segmentValue],
  );

  useEffect(() => {
    if (!restaurants) {
      console.error('Restaurants not fetched');
      return;
    }

    if (!profile?.latitude || !profile?.longitude || (profile?.latitude === 100.0 && profile?.longitude === 200.0)) {
      setTransformedRestaurants(restaurants);
      console.error('User location is not set');
      return;
    }

    if (!isLoaded || !window.google || !window.google.maps || !window.google.maps.geometry) {
      setTransformedRestaurants(restaurants);
      console.error('Google Maps API is not fully loaded.');
      return;
    }

    const userLocation = { lat: profile?.latitude, lng: profile?.longitude };

    const restaurantsWithDistance = restaurants.map(restaurant => {
      if (restaurant.latitude && restaurant.longitude) {
        const distanceMeters = window.google.maps.geometry.spherical.computeDistanceBetween(userLocation, {
          lat: restaurant.latitude,
          lng: restaurant.longitude,
        });
        const distanceMiles = distanceMeters / 1609.34;
        return { ...restaurant, distance: distanceMiles };
      }
      return restaurant;
    });

    setTransformedRestaurants(restaurantsWithDistance);
  }, [profile, restaurants, isLoaded]);

  // TODO: Uncomment when delivery functionality is needed
  // const getLocation = useCallback(address => {
  //   return new Promise((resolve, reject) => {
  //     if (geocodedLocationsCache.current.has(address)) {
  //       resolve(geocodedLocationsCache.current.get(address));
  //       return;
  //     }

  //     if (!geocoderRef.current) {
  //       geocoderRef.current = new window.google.maps.Geocoder();
  //     }

  //     geocoderRef.current.geocode({ address }, (results, status) => {
  //       if (status === window.google.maps.GeocoderStatus.OK && results?.[0]?.geometry?.location) {
  //         const {
  //           geometry: { location },
  //         } = results[0];
  //         geocodedLocationsCache.current.set(address, location);
  //         resolve(location);
  //       } else {
  //         console.error(`Geocoding failed for address: ${address} with status: ${status}`);
  //         reject(new Error(`Geocoding failed: ${status}`));
  //       }
  //     });
  //   });
  // }, []);
  // const filterDeliveryRestaurants = useCallback(
  //   async (rest, deliveryLocation = null) => {
  //     if (!isLoaded || !window.google || !window.google.maps || !window.google.maps.geometry) {
  //       console.error('Google Maps API is not fully loaded.');
  //       return;
  //     }

  //     if (!deliveryLocation) {
  //       if (!addressDetails.streetAddress || !addressDetails.city) {
  //         console.error('No valid delivery address provided.');
  //         return;
  //       }

  //       const deliveryAddress = `${addressDetails.streetAddress}, ${addressDetails.city}, ${addressDetails.state} ${addressDetails.zip}`;
  //       const location = await getLocation(deliveryAddress);
  //       if (location) {
  //         filterDeliveryRestaurants(rest, location);
  //       }
  //       return;
  //     }

  //     const sortedRestaurants = sortRestaurants(rest);
  //     const batchSize = 3;
  //     const batches = Array.from({ length: Math.ceil(sortedRestaurants.length / batchSize) }, (_, i) =>
  //       sortedRestaurants.slice(i * batchSize, (i + 1) * batchSize),
  //     );

  //     const processBatch = async batch => {
  //       const batchResults = await Promise.all(
  //         batch.map(async restaurant => {
  //           const restaurantLocation = await getLocation(restaurant.address);
  //           if (restaurantLocation) {
  //             const distanceMeters = window.google.maps.geometry.spherical.computeDistanceBetween(
  //               deliveryLocation,
  //               restaurantLocation,
  //             );
  //             const distanceMiles = distanceMeters / 1609.34;

  //             if (distanceMiles <= 5) {
  //               return {
  //                 ...restaurant,
  //                 position: restaurantLocation.toJSON(),
  //                 distance: distanceMiles,
  //               };
  //             }
  //           }
  //           return null;
  //         }),
  //       );

  //       return batchResults.filter(Boolean);
  //     };

  //     const processBatches = async () => {
  //       const results = [];
  //       await batches.reduce(async (promise, batch, i) => {
  //         await promise;
  //         const batchResults = await processBatch(batch);
  //         results.push(...batchResults);
  //         if (i < batches.length - 1) {
  //           await new Promise(resolve => {
  //             setTimeout(resolve, 100);
  //           });
  //         }
  //       }, Promise.resolve());
  //       return results;
  //     };

  //     const nearbyRestaurants = await processBatches();
  //     setFilteredRestaurants(nearbyRestaurants.sort((a, b) => a.distance - b.distance));
  //   },
  //   [isLoaded, addressDetails, sortRestaurants, setFilteredRestaurants, getLocation],
  // );

  // TODO: Uncomment when delivery functionality is needed
  // const handleAddressClick = async address => {
  //   try {
  //     setIsLoading(true);

  //     await updateAddress(bearerToken, address);

  //     appDispatchCtx.dispatch({
  //       action: ACTIONS.SET_DELIVERY_ADDRESS,
  //       payload: address,
  //     });

  //     setSelectedRestaurant({ ...appCtx.restaurant, address });
  //     dispatch({ type: 'TRIGGER_GET_LIVE_BETS' });
  //     fetchPastAddresses();

  //     const location = await getLocation(address);
  //     if (location) {
  //       const addressParts = address.split(', ');
  //       const updatedDetails = {
  //         streetAddress: addressParts[0] || '',
  //         apt: '',
  //         city: addressParts[1] || '',
  //         state: addressParts[2]?.split(' ')[0] || '',
  //         zip: addressParts[2]?.split(' ')[1] || '',
  //       };

  //       setAddressDetails(updatedDetails);
  //       setActivePastAddress(address);

  //       if (typeof handleLocationSelect === 'function') {
  //         handleLocationSelect({
  //           lat: location.lat(),
  //           lng: location.lng(),
  //         });
  //       }

  //       setTimeout(() => {
  //         filterDeliveryRestaurants(restaurants, location);
  //         setIsLoading(false);
  //       }, 300);
  //     } else {
  //       setIsLoading(false);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // };

  // TODO: Uncomment when delivery functionality is needed
  // useEffect(() => {
  //   if (isLoaded && addressDetails.streetAddress.trim() !== '' && addressDetails.city.trim() !== '') {
  //     filterDeliveryRestaurants(restaurants);
  //   }
  // }, [addressDetails, isLoaded, filterDeliveryRestaurants, restaurants]);

  const handleCityClick = event => {
    setSelectedCity(event.target.value);
    setSelectingCity(false);
  };

  const formatCity = (city, state) => {
    return state ? `${city}, ${state}` : city;
  };

  return (
    <IonPage>
      <IonContent id='restaurant-page'>
        <IonModal className='select-location-modal' isOpen={selectingCity} onDidDismiss={() => setSelectingCity(false)}>
          <IonHeader className='location-header ion-no-border'>
            <IonToolbar className='location-toolbar ion-no-border'>
              <div className='location-search'>
                <IonIcon
                  className='back-button'
                  slot='start'
                  src={chevronBackCircleOutline}
                  onClick={() => setSelectingCity(false)}
                />
                <IonInput
                  lines='none'
                  className='searchbar'
                  placeholder={selectedCity}
                  value={searchCity}
                  onIonInput={event => setSearchCity(event.detail.value)}
                />
              </div>
              <div className='location-title'>Available Cities</div>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <IonList className='location-list'>
              {[{ state: '', cities: ['All Cities'] }, ...allowedStates]
                .reduce((acc, location) => {
                  const filteredCities = location.cities.filter(city =>
                    `${city} ${location.state}`
                      .toLowerCase()
                      .includes(searchCity.replace(/[, ]+/g, ' ').trim().toLowerCase()),
                  );
                  if (filteredCities.length > 0) {
                    acc.push({ state: location.state, cities: filteredCities });
                  }
                  return acc;
                }, [])
                .map(location => (
                  <div className='state-container' key={location.state}>
                    <div className='state-text'>{location.state}</div>
                    <IonList className='city-container'>
                      {location.cities.map(city => {
                        const formattedCity = formatCity(city, location.state);
                        const selected = formattedCity === selectedCity;
                        return (
                          <IonItem
                            className={`city-button ${selected ? 'selected-city' : 'unselected-city'}`}
                            value={formattedCity}
                            key={city}
                            onClick={handleCityClick}>
                            {city}
                            {selected && <IonIcon className='continue-icon' slot='end' icon={chevronForwardCircle} />}
                          </IonItem>
                        );
                      })}
                    </IonList>
                  </div>
                ))}
            </IonList>
          </IonContent>
        </IonModal>
        <IonHeader className='menu-header ion-no-border'>
          <IonToolbar>
            {segmentValue === 'inPerson' && (
              <IonButtons slot='start'>
                <IonButton class='select-location-button' onClick={() => setSelectingCity(true)}>
                  <IonLabel>{selectedCity}</IonLabel>
                  <IonIcon src={chevronDownCircleOutline} />
                </IonButton>
              </IonButtons>
            )}
            <IonButtons slot='end'>
              <IonSegment
                mode='md'
                className='restaurant-segment'
                value={segmentValue}
                onIonChange={() => {
                  // TODO: Uncomment when delivery functionality is needed
                  // const newVal = e.detail.value;
                  // setSegmentValue(newVal);
                  // if (appCtx.onSelectVenue) {
                  //   appDispatchCtx.dispatch({
                  //     action: ACTIONS.SET_ON_SELECT_VENUE,
                  //     payload: null,
                  //   });
                  // }
                }}>
                <IonSegmentButton className='restaurant-segment-button' value='inPerson'>
                  <IonLabel>In-Person</IonLabel>
                </IonSegmentButton>
                {/* TODO: Uncomment when delivery functionality is needed */}
                {/*  */}
              </IonSegment>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <div className='current-venue-container'>
          <span className='header'>You&apos;re at:</span>
          {appCtx.restaurant?.icon && <img className='rest-icon' src={appCtx.restaurant.icon} alt='Restaurant Icon' />}
          <div className='rest-info'>
            <span className='rest-name'>{appCtx.restaurant?.name || 'Select a Venue'}</span>
            {appCtx.restaurant?.zipcode && <span className='zipcode'>({appCtx.restaurant.zipcode})</span>}
          </div>
        </div>
        <IonSearchbar
          className='venue-searchbar'
          placeholder='Search Venues'
          value={searchVenue}
          onIonInput={event => setSearchVenue(event.detail.value)}
        />
        <IonLabel className='restaurant-grid-title'>Nearby Options</IonLabel>

        {/* TODO: Uncomment when delivery functionality is needed */}
        {/* {segmentValue === 'delivery' && (
          <>
            {isAddressCollapsed ? (
              <div
                className='collapsed-address'
                role='button'
                tabIndex={0}
                onClick={() => setIsAddressCollapsed(false)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setIsAddressCollapsed(false);
                  }
                }}>
                <i className='fa-solid fa-location-dot address-dot' />
                {activePastAddress}
                <div className='arrow-wrapper'>
                  <i className='fa-solid fa-arrow-down collapse-arrow' />
                </div>
              </div>
            ) : null}

            <div className={`address-section-wrapper ${isAddressCollapsed ? 'collapsed' : 'expanded'}`}>
              <AddressFields
                addressDetails={addressDetails}
                setAddressDetails={setAddressDetails}
                setIsFormValid={setIsFormValid}
                className='ion-padding'
                onLocationSelect={handleLocationSelect}
                setIsAddressAutocompleted={dispatchIsAddressAutocompleted}
              />

              <IonButton
                className='delivery-save-button'
                onClick={() => {
                  handleAddressSubmit();
                  setIsAddressCollapsed(true);
                }}
                disabled={!isFormValid}>
                Save
              </IonButton>

              <span className='small-title'>Past Addresses</span>
              {pastAddresses.length > 0 &&
                pastAddresses.slice(0, 2).map(address => (
                  <IonButton
                    className={`past-address ion-text-wrap ${activePastAddress === address ? 'orange' : ''}`}
                    onClick={() => handleAddressClick(address)}
                    key={address}>
                    <i className='fa-solid fa-location-dot address-dot' />
                    <div className='collpased-address'>{address}</div>

                    <div className='placeholder-block' />
                  </IonButton>
                ))}

              <span className='small-title'>Where you are...</span>
              <IonCard className='restaurant-map'>
                <RestaurantMap restaurants={filteredRestaurants} selectedLocation={selectedLocation} />
              </IonCard>
            </div>
          </>
        )} */}

        {/* TODO: Uncomment when delivery functionality is needed */}
        {/* {(segmentValue === 'inPerson' || (segmentValue === 'delivery' && isAddressCollapsed)) && ( */}
        {segmentValue === 'inPerson' && (
          <IonGrid id='restaurant-grid'>
            <IonRow>
              {/* TODO: Uncomment when delivery functionality is needed */}
              {/* {segmentValue === 'delivery' &&
                isLoading &&
                Array(6)
                  .fill()
                  .map((_, index) => (
                    <IonCol size='1' key={skeletonKeys.current[index]}>
                      <RestaurantSkeletonTile />
                    </IonCol>
                  ))}

              {segmentValue === 'delivery' && !isLoading && filteredRestaurants.length === 0 && (
                <IonCol size='3'>
                  <div className='no-delivery-message'>
                    <p>
                      Sorry! There are no venues within 5 miles of your delivery address. Please try another address.
                    </p>
                  </div>
                </IonCol>
              )} */}

              {sortRestaurants(transformedRestaurants).map(rest => (
                <IonCol size='1' key={rest.id}>
                  <RestaurantTile
                    name={rest.name}
                    distance={rest.distance}
                    address={rest.streetAddress}
                    rating={rest.rating}
                    img={rest.icon}
                    isSelected={
                      appCtx.restaurant?.id === rest.id && appCtx.isDelivery === (segmentValue === 'delivery')
                    }
                    onClick={() => {
                      handleSelectRestaurant(rest);
                      setSelectedRestaurant(rest);
                      modalRef.current.present();
                    }}
                  />
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        )}
      </IonContent>
      <RestaurantModal ref={modalRef} restaurant={selectedRestaurant} isDelivery={segmentValue === 'delivery'} />
    </IonPage>
  );
}

export default Restaurant;
